var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 564,
    height: 840,
    viewBox: "0 0 564 840",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M563.294 478.962V871.984H377.017V479.188C375.133 444.569 360.054 411.987 334.882 388.145C309.71 364.304 276.358 351.015 241.687 351.012C172.686 351.012 115.522 402.581 107.012 469.281C107.012 469.394 107.012 469.516 107.012 469.637C106.311 475.245 105.96 480.892 105.962 486.544V872H-80V0H105.704V194.957C148.278 175.082 194.703 164.814 241.687 164.881C416.83 164.881 559.273 304.804 563.294 478.962Z",
    fill: "#B1CC4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M563.294 478.962V870.643H377.372V485.203C377.372 410.356 316.453 349.672 241.598 349.672C208.413 349.673 176.381 361.85 151.575 383.894C126.769 405.938 110.912 436.317 107.012 469.273C107.012 469.386 107.012 469.507 107.012 469.628C106.694 472.319 106.463 475.057 106.317 477.839V870.651H-80V477.646C-77.1014 351.779 -1.90755 243.78 105.704 193.567V194.956C148.278 175.082 194.703 164.814 241.687 164.88C416.83 164.88 559.273 304.804 563.294 478.962Z",
    fill: "#FCB016"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.277 624.102H-80V872H106.277V624.102Z",
    fill: "#DD3736"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.effc070b672bce69dc2cde569268a30b.svg";
export { ForwardRef as ReactComponent };